<div>
    <div class="modal-header state">
        <button type="button" (click)="close(null)" class="btn btn-icon close" aria-label="Close"><i class="fal fa-times" aria-hidden="true"></i></button>
    </div>
    <div class="modal-body">

        <h1 class="pb-4 text-center">Are you sure you want to delete your cart?</h1>
        <hr class="pb-4"/>

        <div class="d-flex justify-content-between">
            <button class="btn btn-outline-primary" (click)="close(null)">Keep cart active</button>
            <button class="btn btn-primary" (click)="delete()" type="button" name="Remove Item">Delete Cart</button>
        </div>
    </div>
</div>
